import React from "react";
import { useTheme } from "../../context/useThemeContext";
import useAbsoluteWindowStore from "../../stores/absoluteWindowStore";
import useDataStore from "../../stores/dataStore";
import { hexToRGBA } from "../../utility/hexToRGB";

function DraggedTab() {
    const { theme } = useTheme();
    const { windowShowing, position } = useAbsoluteWindowStore(
        (state) => state
    );
    const TabTitle = useDataStore((state) => {
        if (!windowShowing || windowShowing.type !== "Tab") return "undefined";

        return state.data.notes[windowShowing?.tabID].title;
    });

    return (
        <>
            {windowShowing && windowShowing.type === "Tab" && (
                <div
                    className="text-white fixed z-[999] h-[36px] rounded flex items-center opacity-75"
                    style={{
                        pointerEvents: "none",
                        width: windowShowing.width,
                        left: position.x,
                        top: position.y,
                        backgroundColor: theme.headerColor,
                        transform: `translate(-${windowShowing.offset.x}px, -${windowShowing.offset.y}px)`,
                        border:
                            "1px solid " + hexToRGBA(theme.accentColor, 0.5),
                    }}
                >
                    <p className="tabTitle text-sm block pl-3 pr-2  rounded-md text-ellipsis whitespace-nowrap">
                        {TabTitle}
                    </p>
                </div>
            )}
        </>
    );
}

export default DraggedTab;
